/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import { PAGE_SIZES, type Severity } from '../quarantine.types';

// Only columns IQ can sort by; image name is not one of them.
export type ContainerSortField = 'QUARANTINE_TIME' | 'SEVERITY' | 'REPOSITORY' | 'POLICY';

export interface ContainerQuery {
  sortBy: ContainerSortField;
  asc: boolean;
  /** 1-based, like the backend and TablePagination. */
  page: number;
  pageSize: number;
}

export interface QuarantinedContainer {
  /** Opaque, stable id of the image. */
  key: string;
  /**
   * A name that tells the image apart. From IQ it is IQ's generated application name (for example
   * `localhost_8081-docker-proxy-library-node-10`), not a Docker image reference. Null when there is none.
   */
  imageName: string | null;
  /** Null while the source has no tag (IQ sends none). */
  tag: string | null;
  /** Null while the source has no digest (IQ sends none). */
  digest: string | null;
  repositoryName: string;
  policyName: string;
  threatLevel: number;
  severity: Severity;
  quarantineTime: string | null;
}

export interface ContainerPage {
  total: number;
  page: number;
  pageSize: number;
  results: QuarantinedContainer[];
}

export const DEFAULT_CONTAINER_QUERY: ContainerQuery = {
  sortBy: 'QUARANTINE_TIME',
  asc: false,
  page: 1,
  pageSize: PAGE_SIZES[0],
};
